export const KonvaEvent = {
    click: "click",
    contextmenu: "contextmenu",
    dragstart: "dragstart",
    dragmove: "dragmove",
    dragend: "dragend",
    mousedown: "mousedown",
    mousemove: "mousemove",
    mouseup: "mouseup",
    mouseover: "mouseover",
    mouseout: "mouseout",
    mouseenter: "mouseenter",
    transform: "transform",
    wheel: "wheel",
    xChange:'xChange'
}
